import { ORDER_TYPE } from 'common/constants/app.constants';
import { alphaNumericValidatorWithSpecialCharacters, numberValidator, priceValidator } from 'common/utils/validator';

import { formElement } from 'home/view/manage-feasibility/constants';

import { getDate, getFileType } from 'home/view/manage-feasibility/utils';

export const loiExpiryDate = 'loiExpiryDate';

export const formSchema = {
  loiNumber: { ...formElement, validator: alphaNumericValidatorWithSpecialCharacters },
  loiDate: { ...formElement },
  [loiExpiryDate]: { ...formElement },
  loiAmount: { ...formElement, validator: priceValidator },
  files: { ...formElement }
};

export const ignoreKeys = ['touched', loiExpiryDate];

export const getDefaultFiles = (uploadedDocs) => {
  if (uploadedDocs && uploadedDocs.LOI) {
    const documents = uploadedDocs.LOI;
    return Object.keys(documents).reduce((accumulator, documentName) => {
      const splittedValue = (documents[documentName] && documents[documentName].split('loi/')[1]) || '';
      const name = splittedValue || `document${documentName}`;
      const fileType = splittedValue.split('.')[1];
      const type = getFileType(fileType)?.type;

      return accumulator.concat({ name, size: 100, documentName, type });
    }, []);
  }
  return [];
};

export const getDefaultValue = (order) => {
  const loiAmount = order && order.loi && order.loi.loiAmount;
  const loiNumber = order && order.loi && order.loi.loiNumber;
  const loiDate = order && order.loi && order.loi.loiDate;
  const loiExpiryDate = order && order.loi && order.loi.loiExpiryDate;
  const hasLoiDoc = getDefaultFiles(order.documents).length > 0;
  return {
    loiNumber: loiNumber
      ? {
          value: loiNumber,
          errors: [],
          touched: true,
          validator: alphaNumericValidatorWithSpecialCharacters
        }
      : { ...formElement, validator: alphaNumericValidatorWithSpecialCharacters },
    loiDate: loiDate ? { value: getDate(loiDate), errors: [], touched: true } : { ...formElement },
    loiExpiryDate: loiExpiryDate ? { value: getDate(loiExpiryDate), errors: [], touched: true } : { ...formElement },
    loiAmount: loiAmount
      ? {
          value: loiAmount,
          errors: [],
          touched: true,
          validator: priceValidator
        }
      : { ...formElement, validator: priceValidator },
    files: hasLoiDoc
      ? {
          value: 'success',
          errors: [],
          touched: true
        }
      : { ...formElement }
  };
};
